import { useTranslations } from "use-intl";

import { Button } from "@/components/Button";
import { IconLuggage } from "@/components/Icons";
import { RequiredLabel } from "@/features/flights/components/additional-services/RequiredLabel";
import { SelectedInfoBadge } from "@/features/flights/components/additional-services/SelectedInfoBadge";

type Props = {
  required?: boolean;
  selectedAmount?: number;
  onClick: () => void;
};

export const AddBaggageCard = ({
  required,
  selectedAmount,
  onClick,
}: Props) => {
  const t = useTranslations();

  return (
    <div className="relative flex flex-col rounded-3xl bg-white p-1">
      <div className="flex items-center gap-1 p-3">
        <IconLuggage className="size-18 shrink-0" />
        <div>
          <div className="font-medium text-text-primary">
            {t("travellers.addExtraBaggage")}
          </div>
          <div className="mb-1 text-sm text-text-tertiary">
            {t("travellers.carryMore")}
          </div>
          {selectedAmount && selectedAmount > 0 ? (
            <SelectedInfoBadge
              label={t("travellers.xExtraBaggagesSelected", {
                amount: selectedAmount,
              })}
            />
          ) : (
            <SelectedInfoBadge label={t("travellers.nothingSelected")} dimmed />
          )}
        </div>
      </div>
      <div className="p-3 pt-1">
        <Button variant="outlined" fullWidth onClick={onClick}>
          {selectedAmount && selectedAmount > 0
            ? t("travellers.editBaggageSelection")
            : t("travellers.addExtraBaggage")}
        </Button>
      </div>
      {required ? <RequiredLabel /> : null}
    </div>
  );
};
